// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

const SpaModalHeader = props =>
    <header className='spa-claim-modal-header'>
        <FormattedMessage id={`${props.actionToTake}_SPECIAL_ALLOWANCE_CLAIM`}/>
        <div className='button-group'>
            <button onClick={props.onClose}>
                <FormattedMessage id='CANCEL'/>
            </button>
            <button
                className='button-primary'
                onClick={props.onConfirmation}
            >
                <FormattedMessage id='CONFIRM'/>
            </button>
        </div>
    </header>;

SpaModalHeader.displayName = 'SpaModalHeader';
SpaModalHeader.propTypes = {
    actionToTake: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    onConfirmation: PropTypes.func.isRequired
};

export default SpaModalHeader;



// WEBPACK FOOTER //
// ./src/tabm/spa-details/components/modal/modal-header.js